import React from 'react';
import './FeaturedProjects.css';

function FeaturedProjects({ limit }) {
  const allProjects = [
    {
      id: 1,
      title: "Factory Fire Alarm Installation",

      scope: "Complete Design & Commissioning",
      description: "Installed an intelligent addressable fire control system across a 150,000 sq ft manufacturing facility. The network included over 400 optical smoke detectors and 30 manual call points, significantly upgrading their safety infrastructure.",
      icon: "🏭"
    },
    {
      id: 2,
      title: "Warehouse Fire Protection System",

      scope: "Suppression & Extinguishers",
      description: "Equipped a massive supply chain warehouse with a high-pressure fire hose reel network and strategically placed high-capacity ABC powder extinguishers to combat potential Class A and B hazards.",
      icon: "📦"
    },
    {
      id: 3,
      title: "Office Building Fire Safety",

      scope: "Detection & Emergency Protocol",
      description: "Upgraded the fire detection panels for a 12-story corporate building. The project involved integrating conventional zone panels with automated emergency exit lighting and staff evacuation protocols.",
      icon: "🏢"
    },
    {
      id: 4,
      title: "Server Room Suppression System",
      scope: "Gas Suppression (CO2)",
      description: "Designed and implemented an automated CO2 gas suppression system for a highly sensitive tier-3 data center to ensure that any electrical fire could be neutralized rapidly without hardware damage.",
      icon: "💾"
    }
  ];

  const projects = limit ? allProjects.slice(0, limit) : allProjects;

  return (
    <div className="projects-grid">
      {projects.map((project) => (
        <div key={project.id} className="modern-project-card hover-lift">
          <div className="project-icon-banner">
            <span className="project-icon">{project.icon}</span>
          </div>
          <div className="project-info">
            <div className="project-header">
              <h3>{project.title}</h3>
              <span className="client-badge">{project.client}</span>
            </div>
            <p className="project-scope"><strong>Scope:</strong> {project.scope}</p>
            <p className="project-desc">{project.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default FeaturedProjects;
